export default __webpack_public_path__ + "static/media/anhanguera.a1b867b9.png";